class Modal {
  constructor(view = null) {
    this.modal = (view ? view.querySelector('.js-modal') : document.querySelector('.js-modal'));
    this.closeButton = this.modal.querySelector('.js-close');

    this.url = this.closeButton.href;
  }

  close = (e) => {
    if (e.target.getAttribute('data-router-view') === 'modal') {
      window.location.href = this.url;
    }
  }

  init() {
    window.addEventListener('click', this.close, { passive: true });
  }

  destroy() {
    window.removeEventListener('click', this.close);
  }
}

export default Modal;
